import { createContext, useContext } from 'react'

/**
 * @param state
 * @param action
 */
export const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_EVENTS_LIST':
      return {
        ...state,
        events: action.payload
      }
    case 'SET_EVENTS_PAGINATION_INFO':
      return {
        ...state,
        paginationInfo: action.payload
      }
    case 'SET_IS_LOADING_EVENTS':
      return {
        ...state,
        isLoadingEvents: action.payload
      }
    case 'SET_IS_LOADING_NEW_PAGE':
      return {
        ...state,
        isLoadingNewpage: action.payload
      }
    case 'SET_FILTERS_OPTIONS':
      return {
        ...state,
        filters: action.payload
      }
    case 'SET_ROUTER':
      return {
        ...state,
        router: action.payload
      }
    case 'SET_LABELS':
      return {
        ...state,
        labels: action.payload
      }
    default:
      return { ...state }
  }
}

export const initialState = {
  /**
   * These are the CMS that come from the server side injected into the entry point that is set in _cmsModuleMap
   */
  CMSProps: null,
  /**
   * Labels from API
   */
  labels: null,
  events: null,
  filters: null,
  router: null,
  paginationInfo: null,
  isLoadingEvents: false,
  isLoadingNewpage: false
}

export const StateContext = createContext(initialState)

export const useModuleContext = () => useContext(StateContext)
